import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { SEOUtils, pagesSEO } from '../utils/seo';

/**
 * Custom hook to manage SEO meta tags for each page
 * Automatically updates canonical URL, title, and description based on current route
 */
export const useSEO = (customSEO?: {
  title?: string;
  description?: string;
  path?: string;
}) => {
  const location = useLocation();

  useEffect(() => {
    const currentPath = location.pathname;
    
    // Get SEO data for current page or use custom SEO
    const seoData = customSEO || pagesSEO[currentPath as keyof typeof pagesSEO] || pagesSEO['/'];
    
    // Update SEO meta tags
    SEOUtils.updatePageSEO({
      path: customSEO?.path || currentPath,
      title: seoData.title || pagesSEO['/'].title,
      description: seoData.description || pagesSEO['/'].description
    });

    // Scroll to top on route change (optional UX improvement)
    window.scrollTo(0, 0);
  }, [location.pathname, customSEO]);

  return {
    updateSEO: (options: {
      path: string;
      title: string;
      description: string;
    }) => SEOUtils.updatePageSEO(options)
  };
};
